import {imageToWorld, mapImageTransform} from "@/dungeons/geometry/Coordinates.ts";
import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import type {MapTransform} from "@/encounter/model/ViewPort.ts";
import type {Image} from "@/images/Image.ts";
import {sightBlockers} from "@/tabletop/visibility/VisibilityGeometry.ts";
import type {VisibilityPolygon} from "@/tabletop/visibility/VisibilityGeometry.ts";
import {dungeonLightAreas} from "@/tabletop/visibility/LightGeometry.ts";
import {clipLightingSegment} from "@/dungeons/lighting/DirectionalShadows.ts";

export function editorLightingScene(document: LevelGeometryDocument, image: Pick<Image, "width" | "height">,
    polygonCache?: Map<string, VisibilityPolygon>) {
    const start = imageToWorld({x: 0, y: 0}, document);
    const end = imageToWorld({x: image.width, y: image.height}, document);
    const bounds = {minX: start.x, minY: start.y, maxX: end.x, maxY: end.y};
    const blockers = sightBlockers(document, door => door.initialState)
        .flatMap(segment => clipLightingSegment(segment, bounds) ?? []);
    const blockerKey = JSON.stringify(blockers);
    return {bounds, blockers, directionalLight: document.directionalLight,
        lights: dungeonLightAreas(document, blockers, polygonCache, blockerKey), blockerKey};
}

/** Adapt image-space editor placement to the same world-space renderer used by encounters. */
export function editorLightingTransform(document: LevelGeometryDocument,
    imageTransform: {x: number; y: number; scaleX: number}): MapTransform {
    const image = mapImageTransform(document);
    const scale = imageTransform.scaleX / image.scaleX;
    return {scale, x: imageTransform.x - image.x * scale, y: imageTransform.y - image.y * scale};
}
